module.exports = {
    'API_URL': 'https://backendtest.bigplay.gg/',
}
